import React from 'react';
import { Box, ListItem, ListItemText, ListItemIcon } from '@mui/material';

import FiberManualRecordSharpIcon from '@mui/icons-material/FiberManualRecordSharp';
import { TLegalListItem } from 'shared/types/legalPages.interface';

export const CustomListItem = ({ title, description }: TLegalListItem) => (
  <ListItem className="list-legal-pages">
    <ListItemIcon>
      <FiberManualRecordSharpIcon sx={{ fontSize: 12, color: 'primary.main' }} />
    </ListItemIcon>
    <ListItemText>
      {title && (
        <Box component="span" fontWeight={700} sx={{ fontSize: { xs: 14, md: 16, lg: 20 } }}>
          {`${title} `}
        </Box>
      )}
      <Box component="span" sx={{ fontSize: { xs: 14, md: 16, lg: 20 } }}>
        {description}
      </Box>
    </ListItemText>
  </ListItem>
);
